<template>
  <div class="comp-login-guide">
    <div class="guide-shadow"></div>
    <div class="guide-wrap">
      <div class="user-info-wrap">
        <img class="user-icon" :src="hotelIdUrl"/>
        <div class="user-info-content">
          <p>{{userInfo.type === 3 || userInfo.type === 6 ? '商户号': '集团号'}}</p>
          <p class="user-hotel-id">{{userInfo.type === 3 || userInfo.type === 6 ? userInfo.hotelId : userInfo.belongId}}</p>
        </div>
      </div>
      <img class="guide-arrow" :src="arrow" />
      <img class="login-demo" :src="login_demo" />
      <div class="guide-content">
        <p>您的{{userInfo.type === 3 || userInfo.type === 6 ? '商户号': '集团号'}}：<span class="user-belongId">{{userInfo.type === 3 || userInfo.type === 6 ? userInfo.hotelId : userInfo.belongId}}</span></p>
        <p>目前的登录地址完成过渡期后将会下线，</p>
        <p>请通过新地址e.passiontec.cn重新登录。</p>
      </div>
      <div class="login-button" @click="toLogin">
        <div class="re-login">马上登录</div>
      </div>
    </div>
  </div>

</template>

<script>
  import { lxCidTracker } from '@util/lxTracker';
  import login_demo from '@assets/images/loginGuide/login-demo.png';
  import arrow from '@assets/images/loginGuide/arrow.png';
  import hotelIdUrl from '@assets/images/loginGuide/hotelid.png';
  import {setCookie, removeCookie} from '@util/cookie';

  export default {
    data () {
      return {
        login_demo,
        arrow,
        hotelIdUrl
      };
    },
    props: ['userInfo'],
    methods: {
      toLogin () {
        // 埋点，发送短信
        if (this.userInfo.type === 3 || this.userInfo.type === 6) {
          this.$lxBidTracker({bid: 'b_eco_w9slbsru_mc'});
        } else {
          this.$lxBidTracker({bid: 'b_eco_t5v6v6g6_mc'});
        }
        
        let host = window.location.host;
        let domain = '';
        let curEnv = '';
        
        if (host.indexOf('fanxiaojian') >= 0) {
          domain = '.fanxiaojian.cn';
        } else {
          domain = '.passiontec.cn';
        }
        
        if (host.indexOf('test2') >= 0) {
          curEnv = 'test2';
        } else if (host.indexOf('alitest1') >= 0) {
          curEnv = 'alitest1';
        } else if (host.indexOf('alitest') >= 0) {
          curEnv = 'alitest';
        } else if (host.indexOf('pre') >= 0) {
          curEnv = 'pre';
        } else {
          curEnv = 'online';
        }
        if (this.userInfo.type === 3 || this.userInfo.type === 6) {
          curEnv += '_irs';
          setCookie('REDIRECATLOGINIRS', curEnv, 999999, '/', domain);
          removeCookie('OLDLOGINFROMIRS', '/', domain);
        } else {
          curEnv += '_hq';
          setCookie('REDIRECATLOGINHQ', curEnv, 999999, '/', domain);
          removeCookie('OLDLOGINFROMHQ', '/', domain);
        }
        let id = this.userInfo.type === 3 || this.userInfo.type === 6 ? this.userInfo.hotelId : this.userInfo.belongId;
        this.$axios.get(`/hq-agency/user/loginNewUrlSendSms?belongId=${id}&username=${this.userInfo.username}`).then(res => {
          window.location.href=`/account-web/#/${id}/${this.userInfo.username}`;
        }).catch(res => {
          console.log('短信发送失败');
        });

      }
    }
  };
</script>

<style lang="less">
.comp-login-guide {
  .guide-shadow {
    position: fixed;
    z-index: 9999;
    width: 100%;
    height: 100%;
    opacity: 0.75;
    background: #070707;
  }
  .guide-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10000;
    margin-left: -383px;
    margin-top: -249px;
    width: 766px;
    height: 498px;
    overflow-x: auto;
    color: #fff;

    .user-info-wrap {
      position: absolute;
      left: 0;
      top: 52px;
      box-sizing:border-box;
      width: 280px;
      height: 120px;
      background: #016CDF;

      .user-icon {
        position: absolute;
        top: 36px;
        left: 30px;
        width: 44px;
        height: 44px;
      }
      .user-info-content {
        position: absolute;
        top: 36px;
        left: 96px;
        display: inline-block;
      }
      .user-hotel-id {
        font-size: 24px;
        line-height: 50px;
      }
    }
    .guide-arrow {
      position: absolute;
      top: 75px;
      left: 196px;
      z-index: 99;
      width: 269px;
    }
    .login-demo {
      position: absolute;
      top: 0;
      right: 0;
      width: 361px;
    }
    .guide-content {
      position: absolute;
      top: 264px;
      font-size: 22px;

      .user-belongId {
        font-size: 32px;
      }
    }
    .login-button {
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -80px;
      width: 160px;
      height: 52px;
      border: 2px solid #FFFFFF;
      border-radius: 4px;
      text-align: center;
      line-height: 52px;
      font-size: 22px;
    }
    .re-login {
      cursor: pointer;
    }
  } 
}
</style>   


// WEBPACK FOOTER //
// LoginGuide.vue?d16e1db0